import { render, staticRenderFns } from "./exitRegister.vue?vue&type=template&id=1aeeb05b&"
import script from "./exitRegister.vue?vue&type=script&lang=js&"
export * from "./exitRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports